import styled, { css } from 'styled-components';

import { color, font, mixin } from 'utils/styles';
import { Avatar } from 'components';

export const Comment = styled.div`
  position: relative;
  margin-top: 25px;
  ${font.size(15)}
`;

export const UserAvatar = styled(Avatar)`
  position: absolute;
  top: 0;
  left: 0;
`;

export const Content = styled.div`
  padding-left: 44px;
`;

export const Username = styled.div`
  display: inline-block;
  padding-right: 12px;
  padding-bottom: 10px;
  color: ${color.textDark};
  ${font.medium}
`;

export const CreatedAt = styled.div`
  display: inline-block;
  padding-bottom: 10px;
  color: ${color.textDark};
  ${font.size(14.5)}
`;

export const Body = styled.p`
  padding-left: 15px;
  padding-bottom: 10px;
  white-space: pre-wrap;
`;

export const HTMLParsedBody = styled.div`
  padding-left: 15px;
  padding-bottom: 10px;
  white-space: pre-wrap;
`;

const actionLinkStyles = css`
  display: inline-block;
  padding: 2px 0;
  color: ${color.textMedium};
  ${font.size(14.5)}
  ${mixin.clickable}
  &:hover {
    text-decoration: underline;
  }
`;

export const EditLink = styled.div`
  margin-right: 12px;
  ${actionLinkStyles}
`;

export const DeleteLink = styled.div`
  ${actionLinkStyles}
  &:before {
    position: relative;
    right: 6px;
    display: inline-block;
  }
`;

export const Attachment = styled.div`
  display: inline-block;
  padding: 0 15px 10px;
  color: ${color.textMedium};
  ${font.size(14.5)}
`;
